import { render, staticRenderFns } from "./DishPhotos.vue?vue&type=template&id=39c1df1c&scoped=true&"
import script from "./DishPhotos.vue?vue&type=script&lang=js&"
export * from "./DishPhotos.vue?vue&type=script&lang=js&"
import style0 from "./DishPhotos.vue?vue&type=style&index=0&id=39c1df1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1df1c",
  null
  
)

export default component.exports